//import translation function for language translation
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const BudgetBreadCrumb = () => {
  const { t } = useTranslation(); //for translation

  return (
    <nav aria-label="breadcrumb">
      <ul className="breadcrumb">
        <li className="breadcrumb-item">
          <Link to="/dashboard" className="text-secondary">
            {t("Dashboard")}
          </Link>
        </li>
        <li className="breadcrumb-item text-gray-600" aria-current="page">
          {t("Budget")}
        </li>
      </ul>
    </nav>
  );
};

export default BudgetBreadCrumb;
